import {useApp} from '../../../contexts/AppContext';
import {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import config from '../../../config';
import {useAuth} from '../../../contexts/UserContext';

const Page = styled.div`
  padding-top: 93px;
`;

const PageFeatureTitle = styled.div`
  border-top: 6px solid #000000;
  border-bottom: 1px solid #000000;
  padding: 80px 0;
  h2 {
    text-align: center;
    font-size: 26px;
    font-weight: bold;
  }
`;

export default function NotFoundPage() {
  const app = useApp();
  const auth = useAuth();

  useEffect(() => {
    if (auth.isLoggedIn()) {
      app.showHeader();
    } else {
      app.showHeader(true);
    }
    document.title = 'Not found';
  }, []);

  return (
      <Page>
        <PageFeatureTitle>
          <h2>Not found</h2>
        </PageFeatureTitle>
      </Page>
  );
}